import { Link } from "react-router-dom";
import type { Article } from "@/lib/news";
import { formatDate } from "@/lib/news";
import TagBadge from "@/components/base/TagBadge";

interface ArticleListItemProps {
  article: Article;
  order?: number;
}

export default function ArticleListItem({ article, order }: ArticleListItemProps) {
  return (
    <Link
      to={`/detail/${article.id}`}
      className="group block rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/50 animate-fade-up cursor-pointer"
      style={order ? { animationDelay: `${Math.min(order, 8) * 60}ms` } : undefined}
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between md:gap-6">
        <div className="min-w-0 flex-1">
          <div className="mb-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="font-label text-primary-600">{article.categoryName}</span>
            <span className="hidden sm:inline">·</span>
            <span className="hidden sm:inline">来源：{article.source}</span>
            <span>·</span>
            <span>{formatDate(article.publishedAt)}</span>
          </div>
          <h3 className="line-clamp-2 text-base font-medium text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[17px]">
            {article.title}
          </h3>
          <p className="line-clamp-2 mt-2 text-sm leading-6 text-foreground-600">
            {article.summary}
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-2 md:w-40 md:justify-end">
          {article.tags.slice(0, 3).map((tag) => (
            <TagBadge key={tag} label={tag} />
          ))}
        </div>
      </div>
    </Link>
  );
}